import { atomFamily } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const ocActivePageSideMenuState = atomFamily({
  key: "ocActivePageSideMenuState",
  default: "",
  effects_UNSTABLE: [ocPersistAtom],
});

export default ocActivePageSideMenuState;
